import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Argon from "./plugins/argon-kit";
import hljs from "highlight.js";
import AOS from 'aos';
import 'aos/dist/aos.css'; 
import './registerServiceWorker'
import Axios from './plugins/axios'
import Tawk from 'vue-tawk'

Vue.use(Tawk, {
    tawkSrc: 'https://embed.tawk.to/605c71ccf7ce18270933cd95/1f1khp1vj'
})

Vue.use(hljs.vuePlugin);
Vue.prototype.$http = Axios;

Vue.config.productionTip = false;
Vue.use(Argon);
AOS.init(); 
new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
